module.exports = __webpack_public_path__ + "static/media/globalnet.6fa30870.webp";